<template>
	<div class="md-layout">
		<div class="md-layout-item md-medium-size-100 md-size-100">
			<h4>{{translate(locale.addNewAdministrator)}}</h4>
		</div>
		<div class="md-layout-item md-medium-size-100 md-size-100" v-if="!loaded">
			<md-card>
				<md-card-content>
					<loading />
				</md-card-content>
			</md-card>
		</div>

		<div class="md-layout-item md-medium-size-100 md-size-100" v-if="loaded">
			<md-card>
				<md-card-content>
					<div class="md-layout">
						<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
							<div class="md-layout">
								<div class="md-layout-item md-small-size-100 md-size-100 text-right">
									<span class="red">{{translate(locale.required)}}</span>
								</div>
								<div class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-50 md-size-33">
									<md-field>
										<label>{{translate(locale.adminName)}} *</label>
										<md-input type="text" v-model="user.name"></md-input>
									</md-field>
								</div>
								<div class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-50 md-size-33">
									<md-field>
										<label>{{translate(locale.adminUsername)}} *</label>
										<md-input type="text" v-model="user.username"></md-input>
									</md-field>
								</div>
								<div class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-50 md-size-33">
									<md-field>
										<label>{{translate(locale.adminRole)}} *</label>
										<md-select :placeholder="translate(locale.adminRole) + ' *'" v-model="user.role">
											<md-option value="payment-admin">អ្នកគ្រប់គ្រងប្រតិបត្តិការ</md-option>
											<md-option value="film-admin">អ្នកគ្រប់គ្រងរឿង</md-option>
											<md-option value="admin">{{translate(locale.roleAdmin)}}</md-option>
											<md-option value="super-admin">{{translate(locale.roleSuperAdmin)}}</md-option>
										</md-select>
									</md-field>
								</div>
								<div class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-50 md-size-50">
									<md-field>
										<label>{{translate(locale.password)}} *</label>
										<md-input type="password" v-model="user.password"></md-input>
									</md-field>
								</div>
								<div class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-50 md-size-50">
									<md-field>
										<label>{{translate(locale.confirmPassword)}} *</label>
										<md-input type="password" v-model="user.confirm_password"></md-input>
									</md-field>
								</div>
							</div>
						</div>
						<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100 text-right">
							<md-button class="md-raised md-primary" @click="createUser()">{{translate(locale.addNewAdministrator)}}</md-button>
						</div>
					</div>
					
				</md-card-content>
			</md-card>
		</div>
	</div>
		
	</div>

</template>

<script>
	import Editor from '@tinymce/tinymce-vue';
	import { Datetime } from 'vue-datetime';
	export default {
		components: { Datetime, Editor },
		created() {
			// this.getSettings();
		},

		data() {
			return {
				loaded: true,
				user: {
					name: "",
					username: "",
					password: "",
					confirm_password: "",
					role: ""
				},
				errors: []
			}
		},
		methods: {
			createUser() {
				if(!this.checkValidation()) {
					this.$notification.notify({message: "សូមបំពេញព័ត៌មានឱ្យបានគ្រប់គ្រាន់។", icon: 'error', type: 'danger'});
					return;
				}

				this.$http.post(this.config.api + "/user/admin/post", { user: this.user }).then(res => {
					if(res.body.status == 'success') {
						this.$notification.notify({ message: "អ្នកបានបង្កើតគណនីគ្រប់គ្រងដោយជោគជ័យ។", icon: 'check_circle', type: 'success' });
						this.$router.push("/administrators");
					}
				})
			},
			checkValidation() {
				let error = false;

				if(String(this.user.name).length < 3) error = true;
				if(String(this.user.username).length < 3) error = true;
				if(String(this.user.role).length <= 0) error = true;
				if(String(this.user.password).length < 8) error = true;
				if(this.user.confirm_password != this.user.password) error = true;
				
				if(!error) return true;
				else return false;
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/pages/Administrators/New.vue